export default __webpack_public_path__ + "static/media/3.213e0616.png";